import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';
// auth
import {AuthGuard} from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import {LoadingScreen} from 'src/components/loading-screen'

const TransportsPage = lazy(() => import('src/pages/transports/TransportsPage'));
const TransportPage = lazy(() => import('src/pages/transport/TransportPage'));

export const transportsRoutes = [
  {
    path: '/transports',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <TransportsPage />,
      },
      {
        path: ':id',
        element: <TransportPage />,
      },
    ],
  },
];
